import { Route, Routes } from "react-router-dom";
import { BrandPicker } from "./BrandPicker";
import { ModuleNotFound } from "./features/core/components/ModuleNotFound";
import ChatbotRoutes from "./features/chatbot/components/ChatbotRoutes";
import { lazy } from "react";
import { App } from "./App";
import { Brand } from "./features/brand/components/Brand";
import { Location } from "./features/location/components/Location";
import { SignOut } from "./features/core/components/SignOut";
import Heartbeat from "./features/heartbeat/components/Heartbeat";
const HomeRoutes = lazy(() => import("./features/home/components/HomeRoutes"));
const BookingRoutes = lazy(
  () => import("./features/booking/components/BookingRoutes")
);
const CorporateRoutes = lazy(
  () => import("./features/corporate/components/CorporateRoutes")
);
const LeaguesRoutes = lazy(
  () => import("./features/leagues/components/LeaguesRoutes")
);
const LocationsRoutes = lazy(
  () => import("./features/locations/components/LocationsRoutes")
);
const PointOfSaleRoutes = lazy(
  () => import("./features/pointOfSale/components/PointOfSaleRoutes")
);
const ReportsRoutes = lazy(
  () => import("./features/reports/components/ReportsRoutes")
);
const ResourceCalendarRoutes = lazy(
  () => import("./features/resourceCalendar/components/ResourceCalendarRoutes")
);
const ScheduleManagementRoutes = lazy(
  () =>
    import("./features/scheduleManagement/components/ScheduleManagementRoutes")
);
const UserManagementRoutes = lazy(
  () => import("./features/userManagement/components/UserManagementRoutes")
);
const AccountsRoutes = lazy(
  () => import("./features/accounts/components/AccountsRoutes")
);
const ReleasesRoutes = lazy(
  () => import("./features/releases/components/ReleasesRoutes")
);
const KidHubRoutes = lazy(
  () => import("./features/kidhub/components/KidHubRoutes")
);
const AppLauncherRoutes = lazy(
  () => import("./features/appLauncher/components/AppLauncherRoutes")
);

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/heartbeat" element={<Heartbeat />} />
      <Route path="" element={<App />}>
        <Route path="" element={<BrandPicker />} />
        <Route path="sign-out" element={<SignOut />} />
        <Route path=":brandSlug" element={<Brand />}>
          <Route path=":locationSlug" element={<Location />}>
            <Route path="home/*" element={<HomeRoutes />} />
            <Route path="releases/*" element={<ReleasesRoutes />} />
            <Route path="kidhub/*" element={<KidHubRoutes />} />
            <Route path="booking/*" element={<BookingRoutes />} />
            <Route path="corporate/*" element={<CorporateRoutes />} />
            <Route path="leagues/*" element={<LeaguesRoutes />} />
            <Route path="locations/*" element={<LocationsRoutes />} />
            <Route path="point-of-sale/*" element={<PointOfSaleRoutes />} />
            <Route path="reports/*" element={<ReportsRoutes />} />
            <Route
              path="resource-calendar/*"
              element={<ResourceCalendarRoutes />}
            />
            <Route
              path="schedule-management/*"
              element={<ScheduleManagementRoutes />}
            />
            <Route
              path="user-management/*"
              element={<UserManagementRoutes />}
            />
            <Route path="accounts/*" element={<AccountsRoutes />} />
            <Route path="wingman/*" element={<ChatbotRoutes />} />
            <Route path="app-launcher/*" element={<AppLauncherRoutes />} />
            <Route path="*" element={<ModuleNotFound />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
